import { render, staticRenderFns } from "./ProjectPI.vue?vue&type=template&id=52aa7c02&"
import script from "./ProjectPI.vue?vue&type=script&lang=js&"
export * from "./ProjectPI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports